import React from "react";

export const FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 72];

/** Font-size combo widget — the `custom()` escape hatch, same as TableGridPicker. */
export function FontSizePicker({
  value,
  disabled,
  onSelect,
}: {
  value: string | null;
  disabled?: boolean;
  onSelect: (value: string) => void;
}) {
  return (
    <div className="px-4 py-1.5">
      <select
        aria-label="Font Size"
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onSelect(e.target.value)}
        className="w-full text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 disabled:text-gray-400 dark:disabled:text-gray-500 disabled:bg-gray-50 dark:disabled:bg-gray-800"
      >
        <option value="">Font Size</option>
        {FONT_SIZES.map((size) => (
          <option key={size} value={`${size}pt`}>
            {size}pt
          </option>
        ))}
      </select>
    </div>
  );
}
